import { Icon, Notice, Shadow, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box, Button, Text } from 'native-base';
import React from 'react';

import { noticeBatchTicketRequests } from '../../utils';

interface SectionWrapperProps {
  table: React.ReactNode;
  refresher: () => void;
}

interface WrapperProps {
  children: React.ReactNode;
}

const DesktopWrapper: React.FC<WrapperProps> = ({ children }) => (
  <Shadow level={1} borderTopRadius={BoxRadius.sm} flex={1}>
    {children}
  </Shadow>
);

const MobileWrapper: React.FC<WrapperProps> = ({ children }) => (
  <Box flex={1} borderTopRadius={BoxRadius.sm}>
    {children}
  </Box>
);

export const SectionWrapper: React.FC<SectionWrapperProps> = ({ table, refresher }) => {
  const Wrapper = useBreakpointValue({
    base: MobileWrapper,
    sm: DesktopWrapper,
  });

  return (
    <Wrapper>
      <VStack
        w="full"
        bg={{ base: 'transparent', sm: 'neutral.white' }}
        borderTopRadius={BoxRadius.sm}
        flex={1}
        space={{ base: Spacing['inline.xxs'] }}>
        <VStack
          py={{ sm: Spacing['stack.xxs'] }}
          borderBottomWidth={{ sm: '1px' }}
          borderBottomColor="neutral.light"
          px={{ sm: Spacing['inline.xxs'] }}>
          <HStack alignItems="center" justifyContent="space-between">
            <Text
              fontSize={Typography['fontsize.lg']}
              variant="semibold"
              color="brand.primary.principal">
              Minhas cestas
            </Text>
            <Button
              variant="textLink"
              onPress={refresher}
              rightIcon={
                <Icon name="Refresh" size="xxxs" color={Color['brand.tertiary.principal']} />
              }
              _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}>
              Atualizar
            </Button>
          </HStack>
        </VStack>
        <VStack px={{ sm: Spacing['inline.xxs'] }} space={Spacing['inline.xxs']} flex={1} w="full">
          <Notice textObjects={noticeBatchTicketRequests} testId="notice" type="alert" />
          {table}
        </VStack>
      </VStack>
    </Wrapper>
  );
};
